import React, { lazy, Component } from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  size?: 'default' | 'lg' | 'xl';
  href?: string;
  scrollToId?: string;
  variant?: 'primary' | 'white';
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'default',
  href,
  scrollToId,
  variant = 'primary'
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 active:translate-y-0 focus:outline-none focus:ring-4 uppercase tracking-wide';
  const sizeStyles = {
    default: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-6 py-4 text-lg md:text-xl'
  };
  const variantStyles = {
    primary: 'bg-yellow-400 hover:bg-yellow-500 text-blue-950 border-b-4 border-yellow-600 hover:border-yellow-700 focus:ring-yellow-300',
    white: 'bg-white hover:bg-gray-100 text-blue-900 border-b-4 border-gray-300 hover:border-gray-400 focus:ring-gray-300'
  };
  const handleClick = (e: React.MouseEvent) => {
    if (scrollToId) {
      e.preventDefault();
      const element = document.getElementById(scrollToId);
      if (!element) return;
      // Force lazy-loaded images BETWEEN the click point and the target
      // to start loading immediately so they don't push the page down
      // mid-scroll. We trigger their load by changing their loading attr.
      try {
        const lazyImages = document.querySelectorAll('img[loading="lazy"]');
        lazyImages.forEach(img => {
          ;
          (img as HTMLImageElement).loading = 'eager';
        });
      } catch {
        // no-op
      }
      // Two-step scroll: jump instantly close, then smooth-scroll precisely.
      // The instant jump bypasses layout-shift drift entirely.
      const stickyOffset = 8;
      const performScroll = () => {
        const rect = element.getBoundingClientRect();
        const target = rect.top + window.pageYOffset - stickyOffset;
        window.scrollTo({
          top: target,
          behavior: 'smooth'
        });
      };
      performScroll();
      // Safety re-scroll once images have had time to settle.
      window.setTimeout(performScroll, 600);
      window.setTimeout(performScroll, 1200);
    }
  };
  const Component = href ? 'a' : 'button';
  const props = href ? {
    href,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: handleClick
  } : {
    onClick: handleClick
  };
  return (
    // @ts-ignore
    <Component {...props} className={`${`
        ${baseStyles}
        ${sizeStyles[size]}
        ${variantStyles[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
        pt-[14px] pb-[14px] pl-[16px] pr-[16px]
      `} pt-[20px] pb-[20px] pl-[20px] pr-[20px]`} data-id="element-173">
      <span className="font-[700] text-[18px]" data-id="element-174">{children}</span>
      <ArrowRight className="ml-2 h-4 w-4 animate-pulse" data-id="element-175" />
    </Component>
  );
}